import { useQuery } from "@tanstack/react-query"

import { bffApi } from "../apiClient"
import queryKeys from "../queryKeys"

type CartContextResponse = {
  arrival: string
  start: string
  end: string
  numberOfDays: number
  isSeasonProductInCart: boolean
  hasServiceProductInCart: boolean
}

export type CartContext = {
  arrival: Date
  start: Date
  end: Date
  numberOfDays: number
  isSeasonProductInCart: boolean
  hasServiceProductInCart: boolean
}

const useCartContextQuery = (resortId: number) => {
  return useQuery<CartContext | null>({
    queryKey: queryKeys.cartContext(resortId),
    queryFn: async () => {
      const res = await bffApi.get<CartContextResponse>("/cart-context", {
        params: { resortId },
      })

      if (!res.data) return null

      return {
        start: new Date(res.data.start),
        end: new Date(res.data.end),
        arrival: new Date(res.data.arrival),
        numberOfDays: res.data.numberOfDays,
        isSeasonProductInCart: res.data.isSeasonProductInCart,
        hasServiceProductInCart: res.data.hasServiceProductInCart,
      }
    },
    staleTime: 0,
  })
}

export default useCartContextQuery
